export const closerLookConfigs: any = {
    'flanged-2-pcs-design': {
        videoUrl: '/images/Product/2-Piece IC Flanged End Ball Valves With ISO Mounting Pad - Made with Clipchamp.mp4',
        slidesData: [
            {
                id: 1,
                title: 'F15/F30 Flanged Ball Valve',
                subtitle: 'F15/F30 Flanged Ball Valve',
                description: 'Series F15/F30 delivers dependable, zero-leakage isolation in a rugged, full-port flanged ASME B16.34 design ideal for industrial applications.',
            },
            {
                id: 2,
                title: 'Proven​ Performance​',
                subtitle: 'Series F15/F30 Flanged Ball Valves',
                description: 'Series F15/F30 delivers the performance and value you expect in an economical full port flanged design available in sizes from ½” through 12”.',
            },
            {
                id: 3,
                title: 'Standard and​ Specialty Alloys​',
                subtitle: 'Series F15/F30 Flanged Ball Valves',
                description: 'Available standard A351 Gr CF8M and ASTM A216 Gr. WCB plus a wide variety of optional specialty alloys including Alloy 20, Duplex, Hastaloy®, Monel®.',
            },
            {
                id: 4,
                title: 'Seat Design',
                subtitle: 'Series F15/F30 Flanged Ball Valves',
                description: 'Series F15/F30 features standard TFM 1600 seats and a wide variety of optional seat materials including Tek-Fil®, PEEK, RPTFE, 50/50, UHMWPE and Metal.',
            },
            {
                id: 5,
                title: 'Cavity Fillers',
                subtitle: 'Series F15/F30 Flanged Ball Valves',
                description: 'Available Body cavity fillers reduce body cavity volume in order to minimize freezing, seizing and trapped media, ensuring smooth valve operation.',
            },
            {
                id: 6,
                title: 'Fugitive Emissions',
                subtitle: 'Series F15/F30 Flanged Ball Valves',
                description: 'The F15/F30’s low-emissions packing design reduces unintended release of hazardous media into the atmosphere, and is certified to ISO 15848-1, API 641, and TA-Luft VDI2440.',
            },
            {
                id: 7,
                title: 'Characterized Control',
                subtitle: 'Series F15/F30 Flanged Ball Valves',
                description: 'Series F15/F30 is offered with standard V-ball ports in 30°, 60° & 90° configurations as well as customized characterization to meet your unique control valve conditions.',
            },
        ],
    },
}